export default "__VITE_ASSET__Aciey$im__"